module.exports = __webpack_public_path__ + "img/arrow_right.ceac2c77.svg";